

















































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'

@Component({
	name: 'EditTable',
	components: {},
})
export default class EditTable extends Vue {
	@Prop()
	private title!: any // 标题
	@Prop({
		default: false,
	})
	private isSubTitle!: boolean // 是否为副标题
	@Prop()
	private checkbox?: any // 勾选框
	@Prop()
	private list!: any // 数据列表
	@Prop()
	private modal!: any // 数据列表
	@Prop({
		default: 'small',
	})
	private size?: string // 表单大小
	@Prop({
		default: true,
	})
	private needIndex?: boolean // 序号
	@Prop({
		default: true,
	})
	private needDelButton?: boolean // 删除按钮
	@Prop({
		default: true,
	})
	private isLikeTable?: boolean // 表格风格

	private listTemp: any[] = []

	private checked: boolean = false

	@Watch('list', { deep: true })
	private onInfoSetChange(v: any[]) {
		this.listTemp = v
	}

	@Watch('checkbox', { deep: true })
	private onCheckBoxChange(val: any) {
		val && (this.checked = val.checked)
	}

	private mounted() {
		this.onInfoSetChange(this.list)
		this.onCheckBoxChange(this.checkbox)
	}

	get requiredList() {
		return this.listTemp.map(element => {
			console.log(element)
			return this.getRequiredForm(element.list)
		})
	}

	private getRequiredForm(list: any) {
		let form: any = {}
		list.forEach((item: any) => {
			form[item.key] = item.value
		})
		return form
	}

	private daterangeChange(date: any, formList: any, index: number) {
		this.$nextTick(() => {
			let refs: any = this.$refs['requiredForm']
			refs[index].validateField('dateArr')
			refs[index].validateField('timeArr')
		})
	}

	private getDisable(item: any, formList: any) {
		return formList.disabled || !item.canEdit
	}

	private getRules(item: any, formList: any) {
		let rules = [
			{
				required: !formList.disabled && item.notNull == '1',
				message: `${item.label}不能为空`,
				trigger:
					item.type == 'date' ||
					item.type == 'datetime' ||
					item.type == 'daterange'
						? ['change']
						: ['blur'],
			},
		]
		if (item.rules) {
			rules = rules.concat(item.rules)
		}
		return rules
	}

	private initPlaceholder(item: any, tips: string) {
		return item.canEdit ? (item.tips ? item.tips : tips) : ''
	}

	private addClickFun() {
		this.list.push({
			list: cloneDeep(this.modal),
		})
	}

	private selectSearch(val: any, key: any, formNum: number) {
		this.$emit('selectSearch', val, key, formNum)
	}

	private dropdownVisibleChange(
		val: any,
		key: any,
		formNum: number,
		formList: any
	) {
		this.$emit('dropdownVisibleChange', val, key, formNum, formList)
	}

	private selectChange(
		val: any,
		key: any,
		formNum: number,
		formList: any,
		listTemp: any
	) {
		this.$emit('selectChange', val, key, formNum, formList, listTemp)
	}

	private dateChange(val: any, key: any, formNum: number, formList: any) {
		this.$emit('dateChange', val, key, formNum, formList)
		this.$nextTick(() => {
			let refs: any = this.$refs['requiredForm']
			refs[formNum].validateField('birthday')
		})
	}

	private delClickFun(formNum: number, item: any) {
		this.list.splice(formNum, 1)
	}

	private checkboxChange(e: any) {
		this.checkbox.checked = e.target.checked
	}

	private inputChange(val: any, key: any, formNum: number, formList: any) {
		this.$emit('inputChange', val, key, formNum, formList)
	}
	private filterOption(input: string, option: any) {
		return (
			option.componentOptions.children[0].text
				.toLowerCase()
				.indexOf(input.toLowerCase()) >= 0
		)
	}

	// 校验表单
	public validateFormData() {
		let flag = true
		if (!this.checked) {
			// 未勾选
			let refs: any = this.$refs['requiredForm']
			if (refs && refs.length) {
				// 列表存在时
				for (let index = 0; index < refs.length; index++) {
					refs[index].validate((valid: boolean, object: any) => {
						if (!valid) {
							// 做错误提示
							const arr = Object.keys(object)
							if (arr.length > 0) {
								const rules = object[arr[0]]
								if (rules.length > 0) {
									this.$message.error(`${this.title}-${rules[0].message}`)
								}
							}
							flag = false
							return false
						} else {
							flag = true
						}
					})

					if (!flag) {
						break
					}
				}
			} else {
				// 列表不存在时
				flag = false
				this.$message.error(`${this.title}-需要填写数据，不能为空`)
			}
		}

		return flag
	}
	//清除校验
	private resetValidate() {
		let refs: any = this.$refs['requiredForm']
		for (const iterator of refs) {
			iterator.resetFields()
		}
	}
}
